export default "__VITE_ASSET__XHll7ktd__"